import { tx } from '@/translations/translations';
export const BANK_INFO = { name: 'Raymond Zeitouni Farca', bank: 'Mifel', clabe: '042180016008044011' };
export const SHIPPING_FEE = 50;

export const inputClass = "w-full px-2.5 py-1.5 border border-slate-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500";

export const getCheckoutText = (language) => {
  if (language === 'he') return {
    title: 'תשלום', cart: 'הסל שלך', empty: 'הסל שלך ריק',
    total: 'סה״כ', shipping: 'משלוח (מקסיקו סיטי והמדינה)', subtotal: 'סכום ביניים',
    payPaypal: 'תשלום עם PayPal', payTransfer: 'העברה בנקאית',
    selectMethod: 'בחרו אמצעי תשלום',
    success: 'ההזמנה הושלמה בהצלחה!', error: 'שגיאה בעיבוד התשלום',
    back: 'חזרה', addressTitle: 'כתובת למשלוח',
    fullName: 'שם מלא', street: 'רחוב ומספר',
    city: 'עיר', state: 'מדינה', zip: 'מיקוד',
    size: 'מידה', color: 'צבע', qty: 'כמות',
    tradition: 'מסורת', threads: 'חוטים', cottonType: 'סוג כותנה',
    transferTitle: 'פרטי העברה בנקאית', transferHolder: 'בעל החשבון',
    transferBank: 'בנק', transferClabe: 'CLABE',
    transferNote: 'בצעו את ההעברה וההזמנה תאושר לאחר אימות התשלום.',
    transferSubmit: 'כבר ביצעתי את ההעברה',
    transferSuccess: 'ההזמנה נרשמה. ניצור קשר לאישור התשלום.',
    copied: 'CLABE הועתק', shippingNote: 'משלוחים רק למקסיקו סיטי ולמדינת מקסיקו',
    completeAddress: 'השלימו את הכתובת כדי להמשיך',
    processing: 'מעבד...'
  };
  return language === 'es' ? {
  title: 'Checkout', cart: 'Tu Carrito', empty: 'Tu carrito está vacío',
  total: 'Total', shipping: 'Envío (CDMX y Edo. Méx.)', subtotal: 'Subtotal',
  payPaypal: 'Pagar con PayPal', payTransfer: 'Transferencia Bancaria',
  selectMethod: 'Selecciona método de pago',
  success: '¡Pedido completado exitosamente!', error: 'Error al procesar el pago',
  back: 'Regresar', addressTitle: 'Dirección de Envío',
  fullName: 'Nombre Completo', street: 'Calle y Número',
  city: 'Ciudad / Alcaldía', state: 'Estado', zip: 'Código Postal',
  size: 'Talla', color: 'Color', qty: 'Cant',
  tradition: 'Tradición', threads: 'Hilos', cottonType: 'Tipo algodón',
  transferTitle: 'Datos para Transferencia', transferHolder: 'Titular',
  transferBank: 'Banco', transferClabe: 'CLABE',
  transferNote: 'Realiza la transferencia y tu pedido será confirmado al verificar el pago.',
  transferSubmit: 'Ya realicé la transferencia',
  transferSuccess: 'Pedido registrado. Te contactaremos para confirmar tu pago.',
  copied: 'CLABE copiada', shippingNote: 'Envíos solo a CDMX y Estado de México',
  completeAddress: 'Completa la dirección para continuar',
  processing: 'Procesando...'
} : {
  title: 'Checkout', cart: 'Your Cart', empty: 'Your cart is empty',
  total: 'Total', shipping: 'Shipping (CDMX & Edo. Méx.)', subtotal: 'Subtotal',
  payPaypal: 'Pay with PayPal', payTransfer: 'Bank Transfer',
  selectMethod: 'Select payment method',
  success: 'Order completed successfully!', error: 'Error processing payment',
  back: 'Go Back', addressTitle: 'Shipping Address',
  fullName: 'Full Name', street: 'Street Address',
  city: 'City', state: 'State', zip: 'ZIP Code',
  size: 'Size', color: 'Color', qty: 'Qty',
  tradition: 'Tradition', threads: 'Threads', cottonType: 'Cotton type',
  transferTitle: 'Bank Transfer Details', transferHolder: 'Account Holder',
  transferBank: 'Bank', transferClabe: 'CLABE',
  transferNote: 'Make the transfer and your order will be confirmed once payment is verified.',
  transferSubmit: 'I already made the transfer',
  transferSuccess: 'Order registered. We will contact you to confirm your payment.',
  copied: 'CLABE copied', shippingNote: 'Shipping only to CDMX and Estado de México',
  completeAddress: 'Complete the address to continue',
  processing: 'Processing...'
};
};

export const getVariantLabels = (language) => ({
  tLabels: { ashkenazi: tx(language, 'Ashkenazi', 'Ashkenazi', 'אשכנזי'), sefaradi: tx(language, 'Sefaradí', 'Sephardic', 'ספרדי'), no_amarrados: tx(language, 'No Amarrados', 'Not Tied', 'לא קשורים') },
  hLabels: { avodat_yad_grueso: tx(language, 'A Mano Gruesos', 'Handmade Thick', 'עבודת יד עבים'), avodat_yad_delgado: tx(language, 'A Mano Delgados', 'Handmade Thin', 'עבודת יד דקים'), mechona_delgado: tx(language, 'A Máquina', 'Machine', 'מכונה'), sin_hilos: tx(language, 'Sin Hilos', 'No Threads', 'ללא חוטים') },
  cLabels: { cotton_smooth: tx(language, 'Liso', 'Cotton Smooth', 'חלק'), cotton_edge: tx(language, 'Acanalado', 'Cotton Ribbed', 'מצולע') },
});
